import {Component, OnInit, AfterViewInit, Input, Output, EventEmitter} from '@angular/core';
import {trigger, style, animate, transition, query, keyframes} from '@angular/animations';
import {CommonService} from "../common.service";
import {ApiService} from "../api.service";

@Component({
  selector: 'app-case-practice-authorization-begin',
  animations: [
    trigger('taskBookAnimation', [
      transition('void => *', [
        style({opacity: 0}),
        query('#taskWrap', style({opacity: 0})),
        query('#text', style({opacity: 0})),
        query('#startBtn', style({opacity: 0})),
        animate('200ms', style({opacity: 1})),
        query('#taskWrap', animate('200ms', keyframes([
          style({transform: 'scale(0.1, 0.1)', opacity: 0.1}),
          style({transform: 'scale(0.2, 0.2)', opacity: 0.2}),
          style({transform: 'scale(0.3, 0.3)', opacity: 0.3}),
          style({transform: 'scale(0.4, 0.4)', opacity: 0.4}),
          style({transform: 'scale(0.5, 0.5)', opacity: 0.5}),
          style({transform: 'scale(0.6, 0.6)', opacity: 0.6}),
          style({transform: 'scale(0.7, 0.7)', opacity: 0.7}),
          style({transform: 'scale(0.8, 0.8)', opacity: 0.8}),
          style({transform: 'scale(0.9, 0.9)', opacity: 0.9}),
          style({transform: 'scale(1, 1)', opacity: 1})
        ]))),
        query('#text', animate('200ms', keyframes([
          style({transform: 'scale(0.1, 0.1)', opacity: 0.1}),
          style({transform: 'scale(0.2, 0.2)', opacity: 0.2}),
          style({transform: 'scale(0.3, 0.3)', opacity: 0.3}),
          style({transform: 'scale(0.4, 0.4)', opacity: 0.4}),
          style({transform: 'scale(0.5, 0.5)', opacity: 0.5}),
          style({transform: 'scale(0.6, 0.6)', opacity: 0.6}),
          style({transform: 'scale(0.7, 0.7)', opacity: 0.7}),
          style({transform: 'scale(0.8, 0.8)', opacity: 0.8}),
          style({transform: 'scale(0.9, 0.9)', opacity: 0.9}),
          style({transform: 'scale(1, 1)', opacity: 1})
        ]))),
        query('#startBtn', animate('200ms', keyframes([
          style({transform: 'scale(0.1, 0.1)', opacity: 0.1}),
          style({transform: 'scale(0.2, 0.2)', opacity: 0.2}),
          style({transform: 'scale(0.3, 0.3)', opacity: 0.3}),
          style({transform: 'scale(0.4, 0.4)', opacity: 0.4}),
          style({transform: 'scale(0.5, 0.5)', opacity: 0.5}),
          style({transform: 'scale(0.6, 0.6)', opacity: 0.6}),
          style({transform: 'scale(0.7, 0.7)', opacity: 0.7}),
          style({transform: 'scale(0.8, 0.8)', opacity: 0.8}),
          style({transform: 'scale(0.9, 0.9)', opacity: 0.9}),
          style({transform: 'scale(1, 1)', opacity: 1})
        ]))),
      ]),
      transition('* => void', [
        style({opacity: 1}),
        query('#taskWrap', animate('200ms', keyframes([
          style({opacity: 1}),
          style({opacity: 0.8}),
          style({opacity: 0.6}),
          style({opacity: 0.4}),
          style({opacity: 0.2})
        ]))),
        query('#text', animate('200ms', keyframes([
          style({opacity: 1}),
          style({opacity: 0.8}),
          style({opacity: 0.6}),
          style({opacity: 0.4}),
          style({opacity: 0.2})
        ]))),
        query('#startBtn', animate('200ms', keyframes([
          style({opacity: 1}),
          style({opacity: 0.8}),
          style({opacity: 0.6}),
          style({opacity: 0.4}),
          style({opacity: 0.2})
        ]))),
        animate('200ms', style({opacity: 0}))
      ])
    ])
  ],
  templateUrl: './case-practice-authorization-begin.component.html',
  styleUrls: ['./case-practice-authorization-begin.component.css']
})
export class CasePracticeAuthorizationBeginComponent implements OnInit, AfterViewInit {

  @Input() exerciseId:number;
  @Input() exerciseMetaId: number;
  @Output() onGoToList = new EventEmitter<any>();
  @Output() onGoToNextStep = new EventEmitter<any>();

  taskBook: any;

  constructor(private commonService:CommonService,
              private apiService: ApiService
             ){}

  ngOnInit(){

    this.apiService.ajax({

      'type':'get',
      'url':'/api/taskBook/'+this.exerciseId

    }).subscribe(result=>{

      this.taskBook = result;

    });
    // this.taskBook = "";
  }

  ngAfterViewInit(){

    this.commonService.initPage({

      'backgroundColor':'white'

    });

  }

  close(){
    this.onGoToList.emit(true);
  }

  goToNextStep(){
    this.commonService.setOnceIno(this.commonService.getOnceValue(this.exerciseMetaId,702)).subscribe();
    this.onGoToNextStep.emit(3);
  }

}



// WEBPACK FOOTER //
// ./src/app/case-practice-authorization-begin/case-practice-authorization-begin.component.ts